import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/login',
      component: () => import('@/layouts/AuthLayout.vue'),
      children: [
        {
          path: '',
          name: 'login',
          component: () => import('@/views/LoginView.vue'),
          meta: { public: true },
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/DashboardView.vue'),
          meta: { title: '标讯情报台', roles: ['GUEST', 'AUDITOR', 'LAB_ENGINEER'] },
        },
        {
          path: 'fatigue',
          name: 'fatigue',
          component: () => import('@/views/FatigueSimView.vue'),
          meta: { title: '拉扭复合疲劳仿真', roles: ['GUEST', 'AUDITOR', 'LAB_ENGINEER'] },
        },
        {
          path: 'qualification',
          name: 'qualification',
          component: () => import('@/views/QualificationView.vue'),
          meta: { title: '关境资质合规自检', roles: ['AUDITOR', 'LAB_ENGINEER'] },
        },
        {
          path: 'admin',
          name: 'admin',
          component: () => import('@/views/AdminView.vue'),
          meta: { title: '系统配置与审计', roles: ['AUDITOR', 'LAB_ENGINEER'] },
        },
      ],
    },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()

  // Auto-provision guest session for public browsing
  if (!auth.token && to.name !== 'login') {
    try {
      await auth.enterAsGuest()
    } catch {
      // allow navigation; API fallbacks handle missing auth
    }
  }

  if (to.meta.public) return true

  const roles = to.meta.roles
  if (roles && !auth.canAccessRoute(to.meta)) {
    return { name: 'dashboard', query: { denied: to.name } }
  }

  // Admin write actions only for LAB_ENGINEER — page itself allows AUDITOR read
  return true
})

export default router
